/* global _ */
import dataService from '../app.service'
import store from '../vuex/store'

export default {
  getTransactionsDataAcquiredWithAdditionalData(userId) {
    if (userId) {
      return this.getTransactionsDataAcquired(userId).then(companies => {
        return _.filter(companies.items, company => {
          return (
            !_.isEmpty(company) &&
            company.data &&
            company.data.entity &&
            company.option === 'advanced'
          )
        })
      })
    } else {
      return Promise.resolve()
    }
  },

  getTransactionsDataAcquired(userId) {
    return dataService.get(`/points/transactions/users/${userId}/entity/access`)
  },

  getUserCohort(user) {
    return _.includes(user.roles, 'source') ? 'source' : 'registered'
  },

  isLoggedIn() {
    return !!this.getUserId()
  },

  getUserToken() {
    if (store.state.user.currentUser) {
      return store.state.user.currentUser.accessToken
    } else {
      return ''
    }
  },
  getUserId() {
    if (store.state.user.currentUser) {
      return store.state.user.currentUser.userId
    } else {
      return ''
    }
  },
}
